module.exports = __webpack_public_path__ + "media/images/cat-de1aff43358708c32d4ee98d2964a453.jpg";